import { Grid } from "@material-ui/core";
import { exceptionCountsWidgetStyle } from "./style";
import ExceptionPieChart from "./ExceptionPieChart";
import WidgetTitle from "../WidgetTitle/WidgetTitle";
import { loadStatuses } from "features/loads/enums";
import ExceptionBarChart from "./ExceptionBarChart";
import { useMemo } from "react";
import { useGetLoadStatusReasonsQuery } from "features/loads/loadsSlice";
import { arrayToObject } from "utils/object-util";

const ExceptionCountsWidget = ({ loads, statuses, loading }) => {
    const classes = exceptionCountsWidgetStyle();

    let loadsFiltered = loads?.filter(l => l?.statuses?.some(s => statuses?.includes(s.status)));

    let { data: statusReasons, error: statusReasonsError, isLoading: isLoadingStatusReasons } = useGetLoadStatusReasonsQuery();
    statusReasons = statusReasons || [];

    const statusReasonsLookup = arrayToObject(statusReasons);

    loadsFiltered = useMemo(() => {
        return loadsFiltered?.map(l => {
            let latestStatusObject = l?.statuses
                ?.filter(s => statuses?.includes(s.status))
                ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))?.[0]
            return ({
                ...l,
                reason: statusReasonsLookup?.[latestStatusObject?.reasonId],
                reasonId: statusReasonsLookup?.[latestStatusObject?.reasonId]?.id,
                reasonOwner: statusReasonsLookup?.[latestStatusObject?.reasonId]?.owner,
                reasonText: statusReasonsLookup?.[latestStatusObject?.reasonId]?.reasonText,
            })
        }
        );
    }, [loads, statuses, statusReasonsLookup]);

    return <Grid container direction="column" className={classes.graphWrapper}>
        <Grid item>
            <WidgetTitle
                title={statuses?.includes(loadStatuses.EXCEPTION) ? 'Exceptions' : 'Cancellations'}
                loading={loading}
            />
        </Grid>
        <Grid container direction="row" spacing={2}>
            <Grid item xs={5}>
                <ExceptionPieChart loads={loadsFiltered} statuses={statuses} />
            </Grid>
            <Grid item xs={7}>
                <ExceptionBarChart loads={loadsFiltered} statuses={statuses} />
            </Grid>
        </Grid>
    </Grid >
}
export default ExceptionCountsWidget;